import { EstadoBeca } from '@/shared/model/enumerations/estado-beca.model';
import { EstadoMovimientoBeca } from '@/shared/model/enumerations/estado-movimiento-beca.model';
import { EventoMovimientoBeca } from '@/shared/model/seguimiento/administrativo/evento-movimiento-beca.model';
import { Persona } from '@/shared/model/persona/persona.model';
import { Beca } from '@/shared/model/seguimiento/beca.model';
import { Programa } from '@/shared/model/seguimiento/programa.model';
import { MotivoMovimientoBeca } from '@/shared/model/seguimiento/administrativo/motivo-movimiento-beca.model';
import { TipoMovimientoBeca } from '@/shared/model/seguimiento/administrativo/tipo-movimiento-beca.model';
import resolveEstadoMovimientoBecaVariant from '@/shared/estados/movimientos-beca.util';
import { Documento } from '@/shared/model/seguimiento/administrativo/documento.model';
import { DependienteEconomico } from '@/shared/model/seguimiento/dependiente-economico.model';
import { Archivo } from '@conacyt/dms-client';
import { BitacoraNotificacionBeca } from '@/shared/model/bitacora-notificacion-beca.model';
import { Apoyo } from '../extranjeras/apoyo.model';
import { Rubro } from '../../rubro.model';

export interface IMovimientoBeca {
  id?: string | null;
  tipoMovimientoBeca?: TipoMovimientoBeca | null;
  motivoMovimientoBeca?: MotivoMovimientoBeca | null;
  estadoActual?: EstadoMovimientoBeca | null;
  eventos?: EventoMovimientoBeca[] | null;
  estadoBecaAnterior?: EstadoBeca | null;
  estadoBecaModificado?: EstadoBeca | null;
  fechaInicioAnterior?: Date | null;
  fechaInicioModificada?: Date | null;
  fechaFinAnterior?: Date | null;
  fechaFinModificada?: Date | null;
  programaAnterior?: Programa | null;
  programaModificado?: Programa | null;
  dependientesEconomicosModificados?: DependienteEconomico[] | null;
  justificacion?: string | null;
  sustentosDocumentales?: Documento[] | null;
  beca?: Beca | null;
  becario?: Persona | null;
  becaId?: string | null;
  fechaRegistro?: string | null;
  fechaAplicacion?: string | null;
  observacionActual?: string | null;
  variant?: string | null;
  consecutivo?: number | null;
  archivos?: Archivo[] | null;
  bitacorasNotificacionBeca?: BitacoraNotificacionBeca[] | null;
  totalRecuperado?: number | null;
  apoyoAnterior?: Apoyo | null;
  apoyoModificado?: Apoyo | null;
  rubrosAnteriores?: Rubro[] | null;
  rubrosModificados?: Rubro[] | null;
  requiereReembolso?: boolean;
  montoReembolso?: number | null;
  anexo_modificatorio?: string | null;
}

export class MovimientoBeca implements IMovimientoBeca {
  constructor(
    public id?: string | null,
    public tipoMovimientoBeca?: TipoMovimientoBeca | null,
    public motivoMovimientoBeca?: MotivoMovimientoBeca | null,
    public estadoActual?: EstadoMovimientoBeca | null,
    public eventos?: EventoMovimientoBeca[] | null,
    public estadoBecaAnterior?: EstadoBeca | null,
    public estadoBecaModificado?: EstadoBeca | null,
    public fechaInicioAnterior?: Date | null,
    public fechaInicioModificada?: Date | null,
    public fechaFinAnterior?: Date | null,
    public fechaFinModificada?: Date | null,
    public programaAnterior?: Programa | null,
    public programaModificado?: Programa | null,
    public dependientesEconomicosModificados?: DependienteEconomico[] | null,
    public justificacion?: string | null,
    public sustentosDocumentales?: Documento[] | null,
    public beca?: Beca | null,
    public becario?: Persona | null,
    public becaId?: string | null,
    public fechaRegistro?: string | null,
    public fechaAplicacion?: string | null,
    public observacionActual?: string | null,
    public variant?: string | null,
    public consecutivo?: number | null,
    public archivos?: Archivo[] | null,
    public tieneNotificaciones?: boolean,
    public bitacorasNotificacionBeca?: BitacoraNotificacionBeca[] | null,
    public totalRecuperado?: number | null,
    public apoyoAnterior?: Apoyo | null,
    public apoyoModificado?: Apoyo | null,
    public rubrosAnteriores?: Rubro[] | null,
    public rubrosModificados?: Rubro[] | null,
    public requiereReembolso?: boolean,
    public montoReembolso?: number | null,
    public anexo_modificatorio?: string | null
  ) {
    this.tipoMovimientoBeca = this.tipoMovimientoBeca ? this.tipoMovimientoBeca : new TipoMovimientoBeca();
    this.motivoMovimientoBeca = this.motivoMovimientoBeca ? this.motivoMovimientoBeca : new MotivoMovimientoBeca();
    this.programaModificado = this.programaModificado ? this.programaModificado : new Programa();
    this.dependientesEconomicosModificados = this.dependientesEconomicosModificados ? this.dependientesEconomicosModificados : [];
    this.beca = this.beca ? this.beca : new Beca();
    this.becario = this.becario ? this.becario : new Persona();
    this.archivos = this.archivos ? this.archivos : [];
    this.bitacorasNotificacionBeca = this.bitacorasNotificacionBeca ? this.bitacorasNotificacionBeca : [];
    this.rubrosAnteriores = this.rubrosAnteriores ? this.rubrosAnteriores : [];
    this.rubrosModificados = this.rubrosModificados ? this.rubrosModificados : [];
  }

  static fromObject(data: IMovimientoBeca): MovimientoBeca {
    const movimientoBeca = new MovimientoBeca();
    for (const [key, value] of Object.entries(data)) {
      movimientoBeca[key] = value;
    }
    movimientoBeca['variant'] = resolveEstadoMovimientoBecaVariant(movimientoBeca.estadoActual);
    return movimientoBeca;
  }
}
